import React from 'react'
import ClientClasses from '../../client/ClientClasses'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientClassesPage() {
  return (
    <V3ProfileRouteShell>
      <ClientClasses visualVariant="v3" />
    </V3ProfileRouteShell>
  )
}

